import * as React from 'react';
const SvgPaidMedia = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m84.439 101.069 18.202-15.847c2.899-2.172 5.41-3.338 7.563-3.87 1.529-.378 2.874-.44 4.05-.32.629.063 1.209.18 1.742.325a12.41 12.41 0 0 1 2.128.808c3.3 1.582 3.866 4.998 3.866 4.998l-34.372 29.215a15.483 15.483 0 0 1-10.026 3.687H21.354L17.484 122"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.32 104.576h26.128a6.775 6.775 0 0 0 0-13.547H56.4a7.739 7.739 0 0 1-3.982-1.104l-1.393-.837a27.123 27.123 0 0 0-28.63.446L2 102.64M110.383 81.352H73.61M15.548 81.352H9.742A7.74 7.74 0 0 1 2 73.61v-1.935h119.995v1.935a7.747 7.747 0 0 1-5.806 7.5M13.612 31.031v7.742M13.612 19.419v1.935M13.612 48.45v15.483M77.481 13.612v11.613M77.481 2v1.935M114.253 52.32v11.613M114.253 40.708v1.936M42.644 61.998h31.121a7.738 7.738 0 0 0 7.374-5.38l3.42-10.684c1.022-3.576-1.576-7.161-5.19-7.161l-9.62.024a3.869 3.869 0 0 1-3.88-3.87V24.45a8.904 8.904 0 0 0-8.903-8.903 2.711 2.711 0 0 0-2.71 2.71v14.709l-5.419 5.806H38.773M48.45 61.998V38.773M103.261 34.65l10.751-10.518a7.207 7.207 0 0 0 .005-10.316c-3.15-3.087-8.337-2.792-11.1.629l-.261.324-.281-.324c-2.758-3.42-7.95-3.72-11.1-.634a7.191 7.191 0 0 0 .005 10.32l10.737 10.52a.903.903 0 0 0 1.248 0h-.004ZM31.563 21.146l9.218-8.763c2.487-2.36 2.487-6.231 0-8.597-2.7-2.575-7.147-2.328-9.513.527l-.222.27-.242-.27c-2.366-2.855-6.813-3.102-9.513-.527-2.492 2.375-2.492 6.227 0 8.602l9.203 8.763c.295.28.774.28 1.07 0v-.005Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPaidMedia;
